import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $('#user_email').on('change', function () {
      $('#forgotPassword').attr('href', '/users/password/new?email=' + $(this).val());
    });
    $('#forgotPassword').attr('href', '/users/password/new?email=' + $('#user_email').val());
  }
}